'use client'

import React from 'react'
import Image from 'next/image'
import { Container, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import { Button } from '@quark/button'
import { Reveal, MultiReveal, Animations } from '@quark/animation'
import isMobile from 'ismobilejs'
import styles from './primaryCard.module.scss'

const PrimaryCard = ({ data, variant = 1, setIsModalOpen, setFormSnippet }) => {
  const isMobileDevice = isMobile()?.phone

  return (
    <div className={`${styles.primaryCardContainer} ${styles[`variant${variant}`]}`}>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
        {data?.iconUrl?.url && (
          <Image
            src={data?.iconUrl?.url}
            alt="coverage-icon"
            width={isMobileDevice ? 72 : 88}
            height={isMobileDevice ? 72 : 88}
          />
        )}
        <Container paddingBottom="spacing-16" paddingTop="spacing-20">
          <Text as="p" fontStyle="um_text-2xl/bold" color="static/Primary-onDark">
            {data?.title}
          </Text>
        </Container>
        <Text as="p" fontStyle="um_text-lg/normal" color="static/Secondary-onDark">
          {data?.subtitle || ''}
        </Text>
      </Reveal>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 200 }}>
        <MultiReveal
          as={Flex}
          flexDirection="column"
          alignItems="flex-start"
          paddingTop="spacing-32"
          paddingBottom={{ lg: 'spacing-48', md: 'spacing-32', sm: 'spacing-24' }}
          animationDelays={(i: number) => 300 + i * 100}
          animationProps={{ animation: Animations.FadeIn50px }}>
          {data?.coverageBenefitList?.map((benefit, index) => (
            <div className={styles.benefitListItem} key={index}>
              <Image
                src={benefit?.iconUrl?.url}
                alt="check-mark"
                width={isMobileDevice ? 14 : 20}
                height={isMobileDevice ? 14 : 20}
              />
              <Text as="div" fontStyle="um_text-base/normal" color="static/Secondary-onDark">
                {benefit?.title}
              </Text>
            </div>
          ))}
        </MultiReveal>
      </Reveal>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 400 }}>
        <div className={styles.buttonContainer}>
          <Button
            type="staticOnDarkOutline"
            size="lg"
            onClick={() => {
              setIsModalOpen(true)
              setFormSnippet(data?.formSnippet)
            }}>
            <Text fontStyle="um_text-base/medium" color="static/Primary-onDark">
              {data?.actionText}
            </Text>
          </Button>
        </div>
      </Reveal>
    </div>
  )
}

export default PrimaryCard
